module.exports = __webpack_public_path__ + "img/HorseLongBoneFracturesNoHardwareExists.7e4a103e.jpg";